export default {
    init() {
        this.login();
        this.register();
    },
    login() {
        $('body').on('click', '#login-form-modal button[type="submit"]', function (e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/login',
                data: $('#login-form-modal form').serialize(),
                success: function () {
                    location.href = '/login';
                },
                error: function (response) {
                    let errors = '<div class="row"><div class="col-12"><div class="alert alert-danger" role="alert">';
                    $.each(response.responseJSON.errors, function (index, value) {
                        errors += '<p><strong>' + value + '</strong></p>';
                    });
                    errors += '</div></div></div>';
                    $('#login-form-modal .validation-errors').html(errors);
                }
            });
        });
    },
    register() {
        $('body').on('click', '#register-form-modal button[type="submit"]', function (e) {
            let submitButton = $(this);
            submitButton.hide();
            e.preventDefault();
            $('#register-form-modal form input[name=lead_source]').val(getCookieLayout('lead_source'));
            $.ajax({
                type: 'POST',
                url: '/register',
                data: $('#register-form-modal form').serialize(),
                success: function (data) {
                    submitButton.show();
                    location.href = '/create-organisation';
                },
                error: function (response) {
                    submitButton.show();
                    let errors = '<div class="row"><div class="col-12"><div class="alert alert-danger" role="alert">';
                    $.each(response.responseJSON.errors, function (index, value) {
                        errors += '<p><strong>' + value + '</strong></p>';
                    });
                    errors += '</div></div></div>';
                    $('#register-form-modal .validation-errors').html(errors);
                }
            });
        });
    }
}
